import React, { useState } from "react";
import { Button } from "./Button";
import { api, deleteAllCookies, PLATFORM_ROUTE } from "./helpers";
import { Input } from "./Input";
import router from "next/router";
import { Select } from "./Select";
import { None, Some } from "./helpers/option";
import { AccountSettings } from "./AccountSettings";

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
        dataLayer: any;
    }
}
export function CreateGroup({ token, user, handleToast, setUser, setToken }) {
    const [group, setGroup] = useState({
        name: "",
        group_type: "",
        expected_usage_type: "",
        referral_origin: "",
        referral_details: "",
        claimed_purpose: "",
        is_individual: true
    });
    const [verify, setVerify] = useState<boolean>(false);
    const [groupCreated, setGroupCreated] = useState<boolean>(false);
    const [teamEmail, setEmail] = useState<string>("");
    // const [domainInUse, setInUse] = useState<boolean>(false);
    const domainInUse = false;
    const [tempUser, setTemp] = useState<any>(null);
    const [load, setLoad] = useState<boolean>(false);

    const handleCreateGroup = async () => {
        setLoad(true);

        const resp = await api.create_group_covalent(token, group.name, group.group_type, group.expected_usage_type, group.referral_origin, group.referral_details, group.claimed_purpose);
        if (!resp || resp.error) {
            handleToast({
                error: resp.error,
                error_message: resp.error_message
            });
        } else {
            handleToast({
                title: "Successfully created a group.",
            });
            setGroupCreated(true);
            setTemp(resp.data);

        }
        setLoad(false);
    };

    const handleInviteTeam = async () => {
        const resp = await api.invite_team_covalent(token, teamEmail);
        if (!resp || resp.error) {
            handleToast({
                error: true,
                error_message: resp?.error_message
            });
        } else {
            handleToast({
                title: "Successfully invited team member.",
            });
        }
    };

    const _handleCreateGroupForm = (event: React.FormEvent<any>) => {
        const field = event.currentTarget.id;
        const value = event.currentTarget.value;

        const st: any = group;
        st[field] = value;

        if (field === "group_type") {
            if (value.match(/^individual-/)) {
                st["is_individual"] = true;
            } else {
                st["is_individual"] = false;
            }
        }

        return setGroup({ ...st });
    };

    const _createGroupFormNotOk = () => {
        if (group.group_type.length == 0) {
            return true;
        }

        if (!group.is_individual && group.name.length === 0) {
            return true;
        }

        if (group.expected_usage_type.length == 0) {
            return true;
        }

        if (group.referral_origin.length == 0) {
            return true;
        }

        if (group.claimed_purpose && group.claimed_purpose.length == 0) {
            return true;
        }

        return false;
    };

    const handleReturnToLogin = () => {
        deleteAllCookies();
        setUser(None);
        router.push(`/${PLATFORM_ROUTE}/auth/login`, undefined, { shallow: false });
    };

    return <>
        <div className="signup-container">
            {
                !verify ?
                    <>
                        <h2>{domainInUse ? "There is a group created under this domain" : "You’re about to create a team on the Covalent Platform"}</h2>
                        <p>
                            {domainInUse ? "If you’re not the administrator of this domain, please request an invitation from the administrator." : "If you’re not the administrator of this domain, please request an administrator to create a group."}
                        </p>
                        {user.match({
                            None: () => null,
                            Some: (user) => {
                                return <>
                                    <p><span className="highlight">{user.email}</span> will be the primary account for this team.</p>
                                </>;
                            }
                        })}
                        <div className="button-group">
                            <Button fill onClick={() => {
                                setVerify(true);
                            }}>Continue {domainInUse && "Anyways"}</Button>
                            <Button secondary fill onClick={handleReturnToLogin}>Back to Log In</Button>
                        </div>

                    </>
                    :
                    !groupCreated ?
                        user.match({
                            None: () => null,
                            Some: (user) => {
                                if (user.full_name.length === 0) {
                                    return <AccountSettings token={token} handleToast={handleToast} setUser={setUser} />;
                                }
                                return <>
                                    <h2>Tell us about yourself</h2>

                                    <Select placeholder="Select answer" label="Describe yourself" id="group_type" onChange={_handleCreateGroupForm} >
                                        <option hidden={true} value="">I am a...</option>
                                        <option value="individual-hobbyist">Hobbyist</option>
                                        <option value="individual-student">Student</option>
                                        <option value="individual-pro">Individual Professional</option>
                                        <option value="business-startup">Startup</option>
                                        <option value="business-consultancy">Freelance Contractor / IT Consultancy</option>
                                        <option value="business-enterprise">Business / Enterprise</option>
                                        <option value="business-nonprofit">Nonprofit</option>
                                    </Select>

                                    {!group.is_individual && <Input type="input" label="Name of organization" id="name" autocomplete="organization" placeholder="Enter name" onChange={_handleCreateGroupForm} />}

                                    <Select placeholder="Select answer" label="What do you want to do?" id="expected_usage_type" onChange={_handleCreateGroupForm} >
                                        <option hidden={true} value="">I want to...</option>
                                        <option value="learn">Experiment and learn</option>
                                        <option value="appdev">Integrate my application or service</option>
                                        <option value="bi">Run BI / Data Science queries</option>
                                    </Select>

                                    {(group.expected_usage_type.length > 0 && group.expected_usage_type !== "learn") &&
                                        <Input placeholder="Enter answer" id="claimed_purpose" label={group.expected_usage_type == "appdev" ? "What are you working on?" : "What are you looking to find out?"} onChange={_handleCreateGroupForm} />
                                    }

                                    <Select placeholder="Select answer" label="How did you hear about us?" id="referral_origin" onChange={_handleCreateGroupForm}>
                                        <option hidden={true}>Select one</option>
                                        <option value="hackathon">Hackathon</option>
                                        <option value="convention">Convention</option>
                                        <option value="school program">Assigned to use by a school program</option>
                                        <option value="employer">Assigned to use by your employer or a consulting client</option>
                                        <option value="coworker">Water-cooler conversation</option>
                                        <option value="social media">Social media (Twitter, Discord, Telegram, Reddit)</option>
                                        <option value="blog">Blog post / News article</option>
                                        <option value="online course">Online course</option>
                                        <option value="youtube">YouTube</option>
                                        <option value="search engine">Search engine</option>
                                        <option value="other">Other</option>
                                    </Select>

                                    {group.referral_origin === "youtube" &&
                                        <Input type="input" id="referral_details" label="What were you watching?" placeholder="Video name or URL" onChange={_handleCreateGroupForm} />
                                    }

                                    {group.referral_origin === "blog" &&
                                        <Input type="input" id="referral_details" label="What were you reading" placeholder="Site name or URL" onChange={_handleCreateGroupForm} />

                                    }

                                    {group.referral_origin === "school program" &&
                                        <Input type="input" id="referral_details" label=" School and program name" placeholder="Program, School" onChange={_handleCreateGroupForm} />

                                    }

                                    <div className="cta">
                                        <Button load={load} fill disabled={load || _createGroupFormNotOk()} onClick={handleCreateGroup}>Create</Button>
                                    </div>
                                </>;
                            }
                        })
                        :
                        <>
                            <h2>Invite your team</h2>
                            <Input type="input" label="Email" placeholder="Enter your team member’s email address" onChange={(e) => {
                                setEmail(e.target.value);
                            }} />

                            <div className="button-group">
                                <Button fill onClick={handleInviteTeam}>Invite</Button>
                                <Button fill secondary onClick={() => {
                                    setUser(new Some(tempUser.user));
                                    setToken(tempUser.token);
                                    router.push(`/${PLATFORM_ROUTE}`);
                                }}>I'll invite later</Button>
                            </div>
                        </>


            }

        </div>
        <style jsx>
            {`
            h2{
                font-size: var(--font-size-6);
                line-height: var(--line-height-6);

            }
            .button-group{
                display:flex;
                flex-direction:column;
                gap:1rem;
            }
            .button-group-row{
                display:flex;
                gap:1rem;
                width:100%;
            }
            
            .re-send{
                color:var(--pink);
            }
            .re-send:hover{
                cursor: pointer;
            }
            .signup-container{
                display:flex;
                flex-direction: column;
                gap:1rem;
                max-width:40rem;
                min-width:20rem;
            }
            .highlight{
                color: var(--pink);
            }

            `}
        </style>
    </>;
}
